import type { SelectOption } from './SelectOption.types';

/**
 * `error` outranks `warning`: an answer that is both invalid and unreviewed is first of
 * all invalid, and only one of the two can be painted.
 */
export function getSelectOptionButtonVariant(
  value: SelectOption,
  error: boolean,
  warning = false,
) {
  if (value.selected && error) {
    return 'danger';
  }

  if (value.selected && warning) {
    return 'warning';
  }

  if (value.selected) {
    return 'primary';
  }

  if (error) {
    return 'outline-danger';
  }

  if (warning) {
    return 'outline-warning';
  }

  return 'outline-primary';
}

export function getButtonVariant(error: boolean) {
  if (error) {
    return 'outline-danger';
  }

  return 'outline-primary';
}
